module.exports = __webpack_public_path__ + "static/media/projectPic1.5a452bd1.png";